import { render, staticRenderFns } from "./LicenseCard.vue?vue&type=template&id=18f55ca0"
import script from "./LicenseCard.vue?vue&type=script&lang=js"
export * from "./LicenseCard.vue?vue&type=script&lang=js"
import style0 from "./LicenseCard.vue?vue&type=style&index=0&id=18f55ca0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports